import React, { useEffect, useState } from "react";
import TestingApi from "../../../../api/TestingApi";
import { ESuiteMode, ETestingState } from "../../../../Model/ModuleState";
import {
  ETestingType,
  ImagingTestParameter,
} from "../../../../Model/TestingParameter";
import { getImagerCapabilities } from "../../../../redux/reducers/ImagerCapabilitiesReducer";
import {
  getSuiteMode,
  getSuiteTestingState,
} from "../../../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import CheckBox from "../../../Buttons/CheckBox";
import ToolsContentButton from "../../ToolsCommon/ToolsContentButton";
import ToolsContentTextBox from "../../ToolsCommon/ToolsContentTextBox";
import "../Testing.css";

type Props = {
  imagerIdentifier: string;
};

export default function ImagePlateTest({ imagerIdentifier }: Props) {
  const imagerCapabilitiesCollection = useTypedSelector((state) =>
    getImagerCapabilities(state)
  );
  const suiteMode = useTypedSelector((state) => getSuiteMode(state));
  const testing = useTypedSelector((state) => getSuiteTestingState(state));

  useEffect(() => {
    if (testing.imaging?.state === ETestingState.Started) {
      const parameter = testing.imaging.parameter;
      setTestParameter({
        pauseDuration: parameter?.pauseDuration ?? 20,
        plateBump: parameter?.plateBump ?? true,
      });
    }
  }, [
    testing.imaging?.state,
    testing.imaging?.parameter?.pauseDuration,
    testing.imaging?.parameter?.plateBump,
  ]);

  useEffect(() => {
    if (testing.imaging?.state === ETestingState.Started) {
      setStatus("Counter: " + testing.imaging?.counter ?? "0");
    }
  }, [testing.imaging?.state, testing.imaging?.counter]);

  const isDisabled = suiteMode !== ESuiteMode.Normal;
  const isRunningImagingTest =
    suiteMode === ESuiteMode.Testing &&
    testing.imaging?.state === ETestingState.Started;

  const [status, setStatus] = useState("status....");
  const [testParameter, setTestParameter] = useState({
    pauseDuration: 20,
    plateBump: true,
  } as ImagingTestParameter);

  const runTest = () => {
    TestingApi.doTesting({
      moduleIdentifier: imagerIdentifier,
      type: ETestingType.Imaging,
      imagingTest: testParameter,
    });
  };

  const stopTest = () => {
    TestingApi.stopTesting();
  };

  return (
    <div className={"testing-content"}>
      <ToolsContentTextBox
        disabled={isDisabled}
        label="Pause (in second) : "
        name="pause"
        variant="number"
        isInteger={true}
        onChange={(value) =>
          setTestParameter({
            ...testParameter,
            pauseDuration: +value,
          })
        }
        value={testParameter.pauseDuration}
        minValueInclusive={0}
        inputStyle={{
          border: "1px solid #999999",
          borderRadius: 2,
          height: 24,
        }}
        style={{
          height: 46
        }}
      />

      {imagerCapabilitiesCollection.byId[imagerIdentifier]
        ?.isPlateBumpSupported && (
        <CheckBox
          disabled={isDisabled}
          id="plateBumpBetweenImaging"
          label="Plate Bump Between Imaging"
          name="plateBumpBetweenImaging"
          colorVariant="alternate"
          checked={testParameter.plateBump}
          onChange={() =>
            setTestParameter({
              ...testParameter,
              plateBump: !testParameter.plateBump,
            })
          }
          style={{
            fontSize: 13,
            height: 48
          }}
        />
      )}
      <div className={"testing-status-box"}>
        <p>{status}</p>
      </div>
      <div className={"testing-button-group"}>
        <ToolsContentButton
          text="Stop"
          onClick={stopTest}
          disabled={!isRunningImagingTest}
          variant="primary"
          colorVariant="black"
        />
        <ToolsContentButton
          text="run"
          onClick={runTest}
          disabled={isDisabled}
          variant="primary"
          colorVariant="default"
        />
      </div>
    </div>
  );
}
